// extracted by mini-css-extract-plugin
export default {"root":"CreditedContent-module--root--9126a","externalCollaborator":"CreditedContent-module--externalCollaborator--fbc45"};